<template>
  <article class="TermsText" id="privacy-policy" v-html="privacy"></article>
</template>

<script>
export default {
  name: "Aviso",
  data() {
    return {
      privacy: "",
    };
  },
  async mounted() {
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = () => {
      if (xhttp.readyState == 4 && xhttp.status == 200) {
        this.privacy = xhttp.responseText
          .replace("{", "")
          .replace('"body":"', "")
          .replace('";', "")
          .replace("}", "");
      }
    };
    xhttp.open(
      "GET",
      "https://api-mx-marketing.azure-api.net/sitios/privacidad/aviso" +
        "?ref=" +
        Math.random() * 9999,
      true,
    );
    xhttp.send();
  },
};
</script>

<style lang="stylus" scoped>
@import './TermsText.styl';
</style>
